import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/reevesdotnl/reevesdotnl/src/templates/pdf-view.tsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PublishDate = makeShortcode("PublishDate");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`A new national airborne geophysical coverage (aeromagnectic and gamma-ray
spectrometry) of  Malawi was completed in 2014. A contract to interpret the
results was awarded to the Geological  Survey of Finland (GTK) working in
cooperation with BRGM (France) and brought to completion  early in 2018. Some of
the highlights of this work were presented at a two-day meeting held in  Zomba,
Malawi, January 18-19 this year. A much larger project, GEMMAP, led by BRGM, is
now  underway to improve the geological mapping and mineral potential mapping of
the country. The  first year results of GEMMAP formed the main focus of the
Zomba meeting. `}</p>
    <p>{`The supervision of the GTK Malawi geophysical interpretation was undertaken by
Colin Reeves for  the World Bank. With the completion of the project, Colin has
withdrawn from work of this type  with a track-record of similar projects going
back to the CIDA airborne reconnaissance of  Botswana in 1975. Two big issues
stand out as still needing attention. First, the results of many  such
public-sponsored surveys are still not easily accessible to potential users
worldwide, despite  the advent of the internet (not to mention GIS) in this same
period. Second, the value of the  results to understanding the main features of
Africa's geological architecture at a scale that  crosses many countries still
has to be realised. Colin plans to spend time on this issue in his  retirement.
In the first instance, this will be in the context of IGCP-628, the new
geological map of  Gondwana. `}</p>
    <p>{`The picture below shows a view of the East Africa Rift from the hills above
Zomba, Malawi. Lake  Chilwa may be seen in the distance. The photo was taken on
Colin's January visit. `}</p>
    <PublishDate mdxType="PublishDate" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      